export const primary = {
  main: '#fff',
  light: '#121212',
};
